import React from 'react';

const SpecifikaceStavby = () => {
    return (
        <div id="content" className="specifikace-stavby">
            <div className="container">
                <h1>
                    <strong>Modulová dřevostavba</strong><br />
                    specifikace stavby
                    <div className="circles">
                        <div className="circle-sand">
                            <small>Energetická<br /> třída</small>
                            <span>B</span>
                        </div>
                        <div className="circle-brown">
                            <span>Záruka</span>
                            <strong>20 let</strong>
                            <small>na konstrukci</small>
                        </div>
                    </div>
                </h1>
                <h2>Skladba obvodových stěn</h2>
                <div>
                    <img src="./images/spec-hero.jpg" alt="Specifikace stavby" />
                </div>
                <h4>Základní popis</h4>
                <p>
                    Modulová dřevostavba je moderní typ stavby, který využívá pro svou konstrukci modulární systém, což znamená, že se skládá z předem
                    vyrobených modulů, které sestavujeme v kryté výrobní hale. Jednotlivé moduly jsou následně dovezeny a finálně sestaveny až na místě vašeho
                    pozemku. Tato konstrukční metoda je často používána pro rodinné domy nebo chaty a je založena na použití dřeva jako hlavního stavebního
                    materiálu. Díky tomuto procesu výstavby získáváme bezkonkurečně rychlejší a levnější proces ve srovnání s tradičními stavebními metodami.
                    Vzhledem k tomu, že výroba probíhá uvnitř, jsou moduly vyráběny bez ohledu na nepříznivé povětrnostní podmínky a navíc zcela bez odpadů
                    a hluku na vašem pozemku.
                </p>
                <p>
                    Modulové dřevostavby jsou nejvíce rozšířeny v Evropě (Švédsko, Finsko, Německo, Švýcarsko) a Severní Americe (Kanada). V těchto zemích,
                    kde často panuje extrémní počasí, vidíme, že modulové dřevostavby nemají sebemenší problém s dlouhou životností a spolehlivostí.
                </p>
                <h4>Výhody</h4>
                <ul>
                    <li><strong>Rychlost výstavby</strong> – Díky výrobě modulů ve výrobních halách je stavba rychlejší než u tradičních zděných staveb.</li>
                    <li><strong>Úspora nákladů</strong> – Vzhledem k efektivní výrobě a minimalizaci stavebního odpadu mohou být náklady nižší než u tradičních zděných domů.</li>
                    <li><strong>Přizpůsobitelnost</strong> – Moduly mohou být navrženy a sestaveny podle konkrétních potřeb, což umožňuje snadné přizpůsobení dispozic.</li>
                    <li><strong>Ekologičnost</strong> – Dřevo je obnovitelný materiál a modulární stavby často vyžadují menší energetické nároky během výstavby i provozu.</li>
                </ul>
                <h4>Životnost</h4>
                <p>
                    V případě občasné údržby a správně přiravené izolaci proti vlhkosti může životnost modulové dřevostavby překročit i 100 let.
                </p>
            </div>
            <div className="text-image light-grey-bg">
                <div className="container">
                    <div className="preview">
                        <img src="./images/img02.jpg" alt="Doprava a usazení domu" loading="lazy" />
                    </div>
                    <div className="text">
                        <h3>Doprava a usazení domu</h3>
                        <p>
                            Doprava je realizována jako nadrozměrný náklad se speciálním režimem. V ceně
                            domu je zahrnuto naložení modulů za pomocí jeřábu a transport v okruhu 100 km od
                            výrobní haly. Před samotným transportem je realizována obhlídka pozemku a
                            konzultace. Dopravu zajišťuje dvojice kamionů s doprovodným vozidlem.
                        </p>
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="bottom-text">
                    <h4>Energetická náročnost</h4>
                    <p>
                        Modulové dřevostavby jsou vysoce energeticky efektivní, přičemž mají nízké nároky
                        na energii během výstavby i provozu. Námi nabízené domy nejčastěji disponují
                        průkazem energetické náročnosti budovy ve třídě B, ale na přání zákazníka jsme
                        schopni realizovat i stavbu ve třídě A.
                    </p>
                </div>
            </div>

            <div className="text-image light-grey-bg">
                <div className="container">
                    <div className="preview">
                        <img src="./images/img03.jpg" alt="Základová deska" loading="lazy" />
                    </div>
                    <div className="text">
                        <h3>Základová deska</h3>
                        <p>
                            Společně s domem vám zhotovíme také základovou desku, která je realizována
                            formou betonových patek/pasů dle projektové dokumentace.                        </p>
                        <p>
                            Základová deska je navržena projektantem vždy s ohledem na charakter pozemku a
                            geologickou situaci. Provětrávaná mezera pod domem o výšce cca 25 cm slouží
                            mimo jiné k ventilaci radonu, který se uvolňuje z půdního podloží.                        </p>
                        <p>
                            V kalkulované variantě domu je počítáno s rovinným pozemkem a blízkostí
                            betonárny. V případě víceprací bude tento náklad předem zkalkulován a schválen se
                            zákazníkem.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SpecifikaceStavby;